import { computed } from 'vue'

export function useNameValidation(name: any) {
  const hasMultipleNames = computed(() => {
    const nameParts = name.value.trim().split(/\s+/).filter(Boolean)
    return nameParts.length > 1
  })

  const isValidName = computed(() => {
    const trimmedName = name.value.trim()
    return trimmedName.length >= 4 && hasMultipleNames.value
  })

  return {
    isValidName,
    hasMultipleNames
  }
}